export const agentLibraryStyles = {
  librarySection: {
    background: 'rgba(124, 58, 237, 0.02)',
    borderTop: '1px solid rgba(124, 58, 237, 0.1)'
  },
  searchContainer: {
    display: 'flex',
    gap: '16px',
    marginBottom: '32px',
    flexWrap: 'wrap',
    alignItems: 'center'
  },
  searchBox: {
    flex: 1,
    minWidth: '300px',
    position: 'relative'
  },
  searchInput: {
    width: '100%',
    padding: '12px 16px 12px 48px',
    background: 'rgba(124, 58, 237, 0.05)',
    border: '1px solid rgba(124, 58, 237, 0.2)',
    borderRadius: '8px',
    color: '#ffffff',
    fontSize: '14px',
    outline: 'none'
  },
  searchIcon: {
    position: 'absolute',
    left: '16px',
    top: '50%',
    transform: 'translateY(-50%)',
    color: '#8b5cf6'
  },
  categoryFilter: {
    display: 'flex',
    gap: '8px',
    flexWrap: 'wrap'
  },
  categoryButton: {
    padding: '8px 16px',
    background: 'transparent',
    border: '1px solid rgba(124, 58, 237, 0.3)',
    borderRadius: '20px',
    color: '#cccccc',
    fontSize: '14px',
    cursor: 'pointer',
    transition: 'all 0.3s'
  },
  categoryButtonActive: {
    background: 'rgba(124, 58, 237, 0.2)',
    borderColor: '#8b5cf6',
    color: '#8b5cf6'
  },
  agentsGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(350px, 1fr))',
    gap: '24px'
  },
  agentCard: {
    background: 'rgba(124, 58, 237, 0.05)',
    border: '1px solid rgba(124, 58, 237, 0.2)',
    borderRadius: '12px',
    padding: '24px',
    transition: 'all 0.3s',
    cursor: 'pointer',
    position: 'relative'
  },
  agentHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: '16px'
  },
  agentTitle: {
    fontSize: '18px',
    fontWeight: '600',
    marginBottom: '4px'
  },
  agentCategory: {
    fontSize: '12px',
    color: '#8b5cf6',
    textTransform: 'uppercase',
    letterSpacing: '0.5px'
  },
  agentPrice: {
    fontSize: '14px',
    fontWeight: '600',
    padding: '4px 12px',
    borderRadius: '12px',
    background: 'rgba(139, 92, 246, 0.1)'
  },
  agentDescription: {
    color: '#cccccc',
    lineHeight: 1.5,
    marginBottom: '16px',
    fontSize: '14px'
  },
  agentTags: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '8px',
    marginBottom: '16px'
  },
  tag: {
    fontSize: '12px',
    padding: '4px 8px',
    background: 'rgba(124, 58, 237, 0.1)',
    border: '1px solid rgba(124, 58, 237, 0.3)',
    borderRadius: '12px',
    color: '#d1d5db'
  },
  agentStats: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    fontSize: '12px',
    color: '#9ca3af'
  },
  rating: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px'
  },
  agentActions: {
    display: 'flex',
    gap: '8px',
    marginTop: '16px'
  },
  actionButton: {
    flex: 1,
    padding: '8px 16px',
    background: 'rgba(124, 58, 237, 0.1)',
    border: '1px solid rgba(124, 58, 237, 0.3)',
    borderRadius: '6px',
    color: '#8b5cf6',
    fontSize: '12px',
    fontWeight: '500',
    cursor: 'pointer',
    transition: 'all 0.3s',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '4px'
  }
};